<template>
  <van-row id="category" class="flex-column">
    <!-- NavBar part -->
    <mynavbar></mynavbar>

    <!-- category title -->
    <van-skeleton class="mt-4rem" :row="1" :loading="sloading">
      <van-divider class="mt-4rem" style="font-size: 1.2rem;">{{title}}</van-divider>
    </van-skeleton>

    <!-- content part -->
    <van-skeleton title avatar avatar-shape="square" avatar-size="100px" :row="2" :loading="sloading" style="margin-top: 3rem;">
      <van-list
        v-if="articles.length > 0"
        :v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
        style="padding: 0.5rem;"
      >
        <van-card
          v-for="(item,index) in articles" :key="item.id"
          :title="item.title"
          class="goods-card"
          :thumb="item.coverUrl"
          @click="openDetails(item.id)"
        >
          <template #footer>
            <van-icon name="clock-o" color="#cccccc"> {{item.createTime}} </van-icon>
          </template>
        </van-card>
      </van-list>
      <van-empty v-else description="暂无记录" />
    </van-skeleton>

    <!-- footer part -->
    <myfooter2></myfooter2>

  </van-row>
</template>

<script>
import navbar from '@/view/navbar/navbar'
import footer2 from '@/view/footer/footer2'

const axios = require('axios')

export default {
  name: 'category',
  components: {
    'mynavbar' : navbar,
    'myfooter2' : footer2
  },
  data () {
    return {
      artId: null,
      idChannel: null,
      title: '',
      currPage: 1,
      pageSize: 10,
      intro: '',
      articles: [],
      categoryUrl: '/article/category/',
      detailsUrl: '/article/details/',
      loading: false,
      finished: false,
      sloading: true
    }
  },
  created() {
    this.idChannel = this.$route.params.id
  },
  mounted () {
    this.getChannel()
    // 加载文章列表
    this.getList(this.currPage)
  },
  methods: {
    // 获取栏目信息
    getChannel () {
      var that = this
      axios.get(that.global.apiUrl + '/web/channel?id=' + this.idChannel)
        .then(function (response) {
          if (response.data.success > 0) {
            // console.log(response.data);
            that.title = response.data.data.name
          }
        }
      )
    },
    // 加载更多
    onLoad() {
      console.log("加载更多")
      this.currPage = this.currPage + 1
      this.getList(this.currPage)
    },
    // 加载文章列表
    getList (page) {
      var that = this
      // 文章列表
      axios.get(that.global.apiUrl + '/web/article/list?page=' + page + '&limit=' + that.pageSize + '&idChannel=' + that.idChannel + '&sort=id&order=desc')
        .then(function (response) {
          if (response.data.success && response.data.data.records.length > 0) {
            var articles = response.data.data.records
            // that.total = response.data.data.total
            // that.pages = response.data.data.pages
            for (var index in articles) {
              const item = articles[index]
              // item.digest = item.title
              // item.title = item.title.length > 42 ? item.title.substring(0, 42) + '...' : item.title
              item.coverUrl = that.global.apiUrl + '/file/getImgStream?idFile=' + item.img
              that.articles.push(articles[index])
            }
            that.loading = false
            that.sloading = false
          } else if (response.data.success && response.data.data.records.length == 0) {
            // that.articles = []
            that.loading = false
            that.finished = true
            that.sloading = false
          } else {
            that.$router.push({ name: 'page404'})
          }
        }
      )

    },

    // 打开详情页
    openDetails (id) {
      this.$router.push({ path:'/article/details/'+id })
      // window.location.href = "/article/details/"+id
    }

  }
}
</script>

<style>
.content {
  padding: 1rem;
}
.content img {
  max-width: 100%;
  max-height: 15rem;
  object-fit: cover;
}
.van-card__thumb {
  width: 120px;
}
</style>



// WEBPACK FOOTER //
// src/view/category/category.vue